<template>
    <div>
        <div class="wrapper-body flex-1">
            <ListCorrespondences :nodeId="nodeId" />
        </div>
        <v-card>
            <!--Correspondence Dialog-->
            <v-dialog v-model="correspondenceDialogOpened" content-class="create-document-dialog fullscreen-dialog corr_dialog" fullscreen v-bind:persistent="true">
                <div id="correspondenceDialogEmptyDiv"></div>
                <CreateDocumentView :documentId="correspondenceDialogObject.documentId"
                                    :transferId="correspondenceDialogObject.transferId"
                                    :viewMode="correspondenceDialogObject.viewMode"
                                    :delegationId="correspondenceDialogObject.delegationId"
                                    :toEmail="correspondenceDialogObject.toEmail"
                                    :emailCC="correspondenceDialogObject.emailCC"
                                    :closeDialogEvent="CloseCorrespondenceDialog"
                                    :openedFromNodeId="correspondenceDialogObject.openedFromNodeId" />
            </v-dialog>
        </v-card>
    </div>
</template>

<script>
    import ListCorrespondences from '@/components/ListCorrespondences.vue';
    import CreateDocumentView from '@/views/CreateDocumentView.vue'

	export default {
		name: 'InboxView',
        components: { CreateDocumentView,ListCorrespondences },
        data () 
        {
            return {
                nodeId: 0,
                correspondenceDialogOpened: false,
                correspondenceDialogObject: {
                    documentId: 0,
                    transferId: 0,
                    viewMode: 'edit',
                    delegationId: 0,
                    toEmail: "",
                    emailCC: "",
                    closeDialogEvent: 0,
                    openedFromNodeId: 1,
                },
            }
        },
        mounted () 
        {
            this.nodeId = 1
            if (sessionStorage.getItem("docId")) {
                let docId = sessionStorage.getItem("docId");
                this.OpenCorrespondenceDialog(docId)
                sessionStorage.removeItem('docId');
            }
        },
        methods: {
            OpenCorrespondenceDialog(docId) {
                this.correspondenceDialogObject.documentId = Number(docId);
                this.correspondenceDialogOpened = true;
            },
            CloseCorrespondenceDialog() {
                this.correspondenceDialogObject.transferId = this.correspondenceDialogObject.documentId = this.correspondenceDialogObject.delegationId = 0;
                this.correspondenceDialogOpened = false;
            },
        }
	}
</script>